/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>chatAPI</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="编号：">
        <el-input size="small" v-model="formInline.no" placeholder="输入chatAPI编号"></el-input>
      </el-form-item>
      <el-form-item label="名称：">
        <el-input size="small" v-model="formInline.name" placeholder="输入chatAPI名称"></el-input>
      </el-form-item>
      <el-form-item label="调用平台：">
        <el-input size="small" v-model="formInline.platform" placeholder="输入chatAPI调用平台"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" placeholder="全部">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新增</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">下载</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column  prop="no" label="编号" width="200">
      </el-table-column>
      <el-table-column  prop="name" label="名称" width="200">
      </el-table-column>
      <el-table-column  prop="platform" label="调用平台" width="200">
      </el-table-column>
      <el-table-column  prop="type" label="类型" width="200">
      </el-table-column>
      <el-table-column  prop="deptNo" label="状态" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.status=='normal'">正常</div>
          <div v-if="scope.row.status=='disabled'">禁用</div>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="success" @click="handleCopy(scope.row)">key复制</el-button>
          <el-button size="mini" type="danger" @click="statusEdit(scope.$index, scope.row)" v-if="scope.row.status=='normal'">禁用</el-button>
          <el-button size="mini" type="primary" @click="statusEdit(scope.$index, scope.row)" v-else>启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog">
      <el-form label-width="140px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="API名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="调用平台" prop="platform">
          <el-input size="small" v-model="editForm.platform" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-input size="small" v-model="editForm.type" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item> -->
        <el-form-item label="类型" prop="type">
          <el-radio v-model="editForm.type" label="text">文本类</el-radio>
          <el-radio v-model="editForm.type" label="image">图片类</el-radio>
        </el-form-item>
        <el-form-item label="知识库选择" prop="k_id" width="250">
          <el-select size="small" v-model="editForm.knowledge[0].id" placeholder="请选择" class="userRole">
            <el-option v-for="type in payTypes" :label="type.name" :value="type.id" :key="type.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否联网搜索" prop="is_online_search">
          <el-radio v-model="editForm.is_online_search" label='0'>否</el-radio>
          <el-radio v-model="editForm.is_online_search" label='1'>嵌入</el-radio>
        </el-form-item>
        <el-form-item label="是否支持附件上传" prop="is_attachment_upload_supported">
          <el-radio v-model="editForm.is_attachment_upload_supported" label="0">否</el-radio>
          <el-radio v-model="editForm.is_attachment_upload_supported" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { chatAPIList, chatAPISavestatus, chatAPICreate,chatAPISave,knowledgeList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      payType: [
        { key: '全部', value: '' },
        { key: '正常', value: 'normal' },
        { key: '禁用', value: 'disabled' },
      ],
      payTypes: [],
      title: '新增',
      editForm: {
        name:'',
        platform:'',
        type:'0',
        is_online_search:'0',
        is_attachment_upload_supported:'0',
        "knowledge": [
          {
            "id": ''
          }
        ]
      },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        platform: [{ required: true, message: '请输入调用平台', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        no: '',
        name: '',
        platform: '',
        status:'null'
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleCopy(row){
      // 创建一个临时的textarea元素
      const textarea = document.createElement('textarea');
      // 设置要复制的文本
      textarea.value = row.api_key;
      // 将元素添加到DOM中
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      // 执行复制命令
      document.execCommand('copy');
      // 移除临时元素
      document.body.removeChild(textarea);
      // 提示用户复制成功
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1000
      });
      
    },
    //启用、禁用
    statusEdit(index, row){
      const msg = row.status === 'normal' ? '确定要禁用吗？' : '确定要启用吗？';
      this.$confirm(msg, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let datas = {kb_id:row.id}
          if(row.status == 'normal'){
            datas.status = 'disabled';
          }else{
            datas.status = 'normal';
          }
          chatAPISavestatus(JSON.stringify(datas))
            .then(res => {
              if (res.message == "success") {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
                this.formInline.status = 'normal',
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(parameter.status=='null'){
        //删除parameter.status参数
        delete parameter.status;
      }
       console.log(parameter,2222)

       chatAPIList(parameter)
        .then(res => {
          this.loading = false
          console.log(res,333333333333333)
          if (res.message == "success") {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.currentPage = res.data.page_info.page
            this.pageparm.pageSize = res.data.page_info.page_size
            this.pageparm.total = res.data.page_info.total_pages
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
         // this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    kdetail() {
      const datas = {
        page: 1,
        limit: 50,
        status: 'normal',
      }
      knowledgeList(datas)
        .then(res => {
          console.log(res,'filesssssssssssssssssss')
          if (res.message == "success") {
             this.payTypes = res.data.items;
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
      },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      //查询知识库
     this.kdetail();
      if (row != undefined && row != 'undefined') {
        this.title = '编辑chatAPI'
        // this.editForm.Id = row.id
        // this.editForm.Name = row.deptName
        // this.editForm.platform = row.deptNo
        // this.editForm.type = row.deptNo
        // this.editForm.k_id = row.deptNo
        // this.editForm.is_network = '0'
        // this.editForm.is_upload = '0'
        this.editForm = row
        if(this.editForm.is_attachment_upload_supported==true){
              this.editForm.is_attachment_upload_supported = '1';
        }else{
          this.editForm.is_attachment_upload_supported = '0';
        }
        if(this.editForm.is_online_search==true){
          this.editForm.is_online_search = '1';
        }else{
          this.editForm.is_online_search = '0';
        }
        //  this.editForm.knowledge.id = this.editForm.knowledge[0].id
      } else {
        this.title = '新增';
        this.editForm.name = '';
        this.editForm.platform = '';
        this.editForm.type = 'text';
        this.editForm.knowledge.id = '';
        this.editForm.is_online_search = '0';
        this.editForm.is_attachment_upload_supported = '0';
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.is_attachment_upload_supported=='1'){
              this.editForm.is_attachment_upload_supported = true;
            }else{
              this.editForm.is_attachment_upload_supported = false;
            }
            if(this.editForm.is_online_search=='1'){
              this.editForm.is_online_search = true;
            }else{
              this.editForm.is_online_search = false;
            }
            console.log(this.editForm,'编辑信息')
            // if(this.editForm.knowledge[0]&&this.editForm.knowledge[0].id){
            //   this.editForm.knowledge.id = this.editForm.knowledge[0].id
            //   delete this.editForm.knowledge[0]
            // }
            // console.log(this.editForm,'编辑信息')
          if(this.title=='新增'){
            chatAPICreate(JSON.stringify(this.editForm))
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.message == "success") {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '新增成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('失败，请稍后再试！')
            })
          }else{
            console.log(this.editForm,222222222)
            chatAPISave(JSON.stringify(this.editForm))
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.message == "success") {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 下线用户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '用户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.userName + '强制下线成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('用户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/chat/api.vue